<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>

            <v-col
              cols="6"
              class="d-flex flex-row-reverse d-md-none d-lg-none d-xl-none"
            >
              <div>
                <v-btn-toggle dense>
                  <v-btn @click="breackPoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>

                  <v-btn @click="breackPoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          item-class="text--red"
          :mobile-breakpoint="breackPoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_lancamento="{ item }">
            <v-btn @click="$copy(item.id_lancamento)" x-small>
              {{ item.id_lancamento }}
            </v-btn>
          </template>

          <template v-slot:item.categoria="{ item }">
            <div class="caption">{{ item.categoria }}</div>
          </template>

          <template v-slot:item.valor="{ item }">
            <span :class="getColor(item.valor)">{{ item.valor }}</span>
          </template>
        </v-data-table>
      </v-card>
      <!-- <router-view></router-view> -->
      <!-- Resume -->
      <div class="mt-4" v-if="data.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="mb-2">
                {{ $t("resumeSummary") }}
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>

              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in resumeCashCollectors"
                      :key="index"
                    >
                      <td class="caption">{{ item.label }}</td>
                      <td class="text-right" :class="getColor(item.value)">
                        {{ item.value }}
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td class="text-right">
                        <b>{{ total }}</b>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "administrator-financial-cash-collectors",
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    data: [],
    resumeCashCollectors: [],
    breackPoint: 0,
    total: 0,
  }),
  computed: {
    headers() {
      return [
        { text: "Id", value: "id_lancamento" },
        { text: this.$t("collector"), value: "nome_arrecadador" },
        { text: this.$t("category"), value: "categoria" },
        { text: this.$t("date"), value: "data_registro" },
        { text: this.$t("value"), value: "valor" },
      ];
    },
    categories() {
      return {
        1: this.$t("lastPickup"),
        2: this.$t("depostiForPaymentOfPremiums"),
        3: this.$t("miscellaneoutDeposit"),
        4: this.$t("reverse"),
      };
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_collector() {
      return this.$store.state.filters.autocompleteCollectors.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.cashCollector();
    },
  },

  methods: {
    async cashCollector() {
      const { id_regional, id_collector, rangeDate } = this;
      const body = { ...rangeDate, id_regional, id_collector };
      const response = await this.$request.post(
        "/administrator/financial/reportCashCollectors",
        body
      );
      this.data = response.cashEntrys;

      if (!this.data) return;

      this.data.forEach((item) => {
        item.data_registro = new Date(
          item.data_registro.replace(" ", "T")
        ).toLocaleString();
        item.categoria = this.categories[item.categoria];
      });
      this.resumeByCategory(this.data);
    },

    resumeByCategory(data) {
      if (!data) return;
      this.resumeCashCollectors = [];
      const sum = (values) => values.reduce((a, b) => a + b, 0).toFixed(2);
      const listCategories = Object.values(this.categories);

      /*
       *   Interação onde monta a lista das somas por categoria
       */
      for (const [index, label] of listCategories.entries()) {
        let arrayValues = this.data.map((item) =>
          item.categoria == this.categories[index + 1] ? Number(item.valor) : 0
        );

        this.resumeCashCollectors.push({
          label,
          value: sum(arrayValues),
        });
      }

      this.total = this.resumeCashCollectors
        .map((item) => Number(item.value))
        .reduce((a, b) => a + b, 0);
    },

    getColor(value) {
      if (value == 0) return "white--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
};
</script>
